var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-rules"},[_c('div',{attrs:{"id":"market-rules"}}),_vm._v(" "),_c('div',{class:_vm.marginBoxClass},[_c('div',{ref:"wrap",class:_vm.wrapperClass},[_c('div',{ref:"content",staticClass:"market-rules__content",domProps:{"innerHTML":_vm._s(_vm.rules)}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9d8a7a90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/market/market-rules/market-rules.vue
// module id = lhE/
// module chunks = 0